import ApiErrorResponse from "@eryxcoop/appyx-comm/src/responses/generalResponses/ApiErrorResponse";

export default class CreateLeadErrorResponse extends ApiErrorResponse {
    static defaultResponse() {
        return {
            object: {},
            errors: [{
                code: 'missing_lead_referral_observation',
                text: 'The observation is required when the lead knew us through Others',
            }],
        };
    }

    static errorCodes() {
        return ['missing_lead_referral_observation', 'arca_unavailable'];
    }
}
